import { useContext } from 'react';
import DialogBoxContext from '../context/DialogBoxContext';

const useDialogBox = () => useContext(DialogBoxContext);

export default useDialogBox;
